import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import {
  HttpErrorResponse
} from '@angular/common/http';
import { throwError } from 'rxjs';
import { UserService } from '../services/user.service';
import { retry, catchError, timeout } from 'rxjs/operators';
import { NotificationService } from '../services/notification.service';
import { MemberService } from '../services/member.service';
import { LoggerService } from '../services/logger.service';

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);
  const userService = inject(UserService);
  const memberService = inject(MemberService);
  const notificationService = inject(NotificationService);
  const logger = inject(LoggerService);
  
  if (isPlatformBrowser(platformId)) {

    let reqHeaders = req.clone({
      headers: req.headers
        .set('Content-Type', 'application/json')
    });


    logger.log('request headers ', req);
    const authToken = localStorage.getItem('auth_token');
    if (authToken) {
      reqHeaders = req.clone({
        headers: req.headers
          .set('Authorization', `Bearer ${authToken}`)
      });


      if (req.method === 'GET') {
        return next(reqHeaders).pipe(
          timeout(20000),
          retry(1),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              memberService.triggerTokenExpired();
              userService.logout('/auth/inloggen');
              notificationService.customToast(
                'Je moet opnieuw inloggen',
                'Oeps'
              );
            }
            return throwError(() => error);
          })
        );
      } else if (req.url.includes('Scrape')) {
        return next(reqHeaders).pipe(
          timeout(30000),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              memberService.triggerTokenExpired();
              userService.logout('/auth/inloggen');
              notificationService.customToast(
                'Je moet opnieuw inloggen',
                'Oeps'
              );
            }
            return throwError(() => error);
          })
        );
      } else {
        return next(reqHeaders).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              logger.log('Token expired');
              memberService.triggerTokenExpired();
              userService.logout('/auth/inloggen');
              notificationService.customToast(
                'Je moet opnieuw inloggen',
                'Oeps'
              );
            }
            return throwError(() => error);
          })
        );
      }
      
    }
  }
  
  return next(req);
};
